import { NgModule } from '@angular/core';
import { translationChunksConfig } from '@spartacus/assets';
import { provideConfig } from '@spartacus/core';
import { defaultB2bOccConfig } from '@spartacus/setup';
import { layoutConfig, mediaConfig } from '@spartacus/storefront';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    provideConfig(defaultB2bOccConfig),
    provideConfig({
      showOrderQuoteLink: true,
    }),
    provideConfig({
      i18n: {
        backend: {
          loader: (lng: string, ns: string) =>
            import(`../../../public/i18n-assets/${lng}/${ns}.json`),
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class SpartacusConfigurationModule {}
